import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useGetUserDetails } from '../api-refactored/user/useGetUserDetails';
import { CUSTOMIZED_UNAUTHORIZED_STATUS_CODE } from '../api/config/misc';
import { useAuth } from '../modules/profile/logic/auth';
import { updateInactivityMinutes, updateServerDateTime } from '../store/appSlice';
import { utcToDefaultDisplay } from '../utils/DateUtils';

/**
 * A react-query hook that will call userDetail - csrf api
 * @returns
 */
interface Input {
  enabled?: boolean;
}

export const useUserDetails = (input: Input = {}) => {
  const { enabled = true } = input;
  const auth = useAuth();
  const dispatch = useDispatch();

  const res = useGetUserDetails({
    enabled,
    onSuccess: (axiosRes) => {
      if (axiosRes.status === 200) {
        if (!auth.isUserLoggedIn) {
          auth.signin();
        }
      } 
      else if (axiosRes.status === 202 && auth.isUserLoggedIn) {
        // Transient 202 after 2FA — the server is still settling the session.
        // Rather than retry here (which creates a refetch loop), let the polling
        // in OneTimePasswordForm.tsx handle the sync, or wait for the next
        // automatic user-details check. Don't sign out on transient 202.
      }
    },
    onError: (err) => {
      if (err.response?.status === CUSTOMIZED_UNAUTHORIZED_STATUS_CODE) {
        auth.signout();
      }
    },
  });

  useEffect(() => {
    if (res.data?.data?.inactivityMinutes) {
      dispatch(updateInactivityMinutes(res.data?.data?.inactivityMinutes));
    }
    if (res.data?.data?.serverDateTime) {
      dispatch(updateServerDateTime(utcToDefaultDisplay(res.data?.data?.serverDateTime)));
    }
  }, [dispatch, res.data?.data?.inactivityMinutes, res.data?.data?.serverDateTime]);

  return res;
};
